module.exports = __webpack_public_path__ + "static/yuangong-975c33f7f58e71e9de28775222a3e8ac.png";